import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const token = localStorage.getItem('prona_userToken') || null

export const blogApi = createApi({
    reducerPath: 'blogApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api`,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (build) => ({
        getBlogs: build.query({
            query: (params) => ({
                url: '/blogs',
                params,
                method: 'GET',
            }),
            providesTags: ['Blogs']
        }),
        getBlogById: build.query({
            query: (id) => ({
                url: `/blogs/${id}`,
                method: 'GET',
            }),
            providesTags: ['Blog']
        }),
        createBlog: build.mutation({
            query: (data) => ({
                // STAGING PATCH: was hardcoded to https://api.pronascout.com —
                // creating a blog from the STAGING dashboard would have written
                // it straight into PRODUCTION. Route via the configured host.
                url: `${process.env.REACT_APP_BACKEND_HOST}/api/admin/blogs/create`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Blogs']
        }),
        deleteBlog: build.mutation({
            query: (id) => ({
                url: `admin/blogs/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Blogs']
        }),
        updateBlog: build.mutation({
            query: ({ data, id }) => ({
                // STAGING PATCH: same as createBlog above — this hardcoded
                // production URL would have let staging edit PRODUCTION blogs.
                url: `${process.env.REACT_APP_BACKEND_HOST}/api/admin/blogs/update/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Blogs', 'Blog']
        }),
        getBlogTypes: build.query({
            query: () => ({
                url: '/admin/blog-types',
                method: 'GET',
            }),
        }),
    })
});

export const {
    useGetBlogsQuery,
    useGetBlogByIdQuery,
    useCreateBlogMutation,
    useDeleteBlogMutation,
    useUpdateBlogMutation,
    useGetBlogTypesQuery,
} = blogApi;
